/* tslint:disable */

declare var Object: any;
export interface SFOnDutySF6Interface {
  "id"?: number;
}

export class SFOnDutySF6 implements SFOnDutySF6Interface {
  "id": number;
  constructor(data?: SFOnDutySF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOnDutySF6`.
   */
  public static getModelName() {
    return "SFOnDutySF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOnDutySF6 for dynamic purposes.
  **/
  public static factory(data: SFOnDutySF6Interface): SFOnDutySF6{
    return new SFOnDutySF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOnDutySF6',
      plural: 'SFOnDutySF6s',
      path: 'SFOnDutySF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOnDutySF6.ts